const ccToLc = {
    AD: 'CAT',
    AE: 'ARA',
    AF: 'ENG',
    AG: 'ENG',
    AI: 'ENG',
    AL: 'SQI',
    AM: 'HYE',
    AN: 'ENG',
    AO: 'ENG',
    AQ: 'ENG',
    AR: 'SPA',
    AS: 'ENG',
    AT: 'ENG',
    AU: 'ENG',
    AW: 'NLD',
    AX: 'SWE',
    AZ: 'ENG',
    BA: 'ENG',
    BB: 'ENG',
    BD: 'BEN',
    BE: 'ENG',
    BF: 'ENG',
    BG: 'BUL',
    BH: 'ARA',
    BI: 'ENG',
    BJ: 'ENG',
    BL: 'FRA',
    BM: 'ENG',
    BN: 'MSA',
    BO: 'ENG',
    BR: 'ENG',
    BS: 'ENG',
    BT: 'DZO',
    BV: 'ENG',
    BW: 'ENG',
    BY: 'ENG',
    BZ: 'ENG',
    CA: 'ENG',
    CC: 'ENG',
    CD: 'ENG',
    CF: 'ENG',
    CG: 'ENG',
    CH: 'ENG',
    CI: 'FRA',
    CK: 'ENG',
    CL: 'ENG',
    CM: 'ENG',
    CN: 'ENG',
    CO: 'SPA',
    CR: 'SPA',
    CU: 'SPA',
    CV: 'ENG',
    CW: 'PAP',
    CX: 'ENG',
    CY: 'ENG',
    CZ: 'CES',
    DE: 'ENG',
    DJ: 'ENG',
    DK: 'ENG',
    DM: 'ENG',
    DO: 'SPA',
    DZ: 'ENG',
    EC: 'ENG',
    EE: 'EST',
    EG: 'ARA',
    EH: 'ENG',
    ER: 'ENG',
    ES: 'ENG',
    ET: 'ENG',
    FI: 'ENG',
    FJ: 'ENG',
    FK: 'ENG',
    FM: 'ENG',
    FO: 'FAO',
    FR: 'ENG',
    GA: 'FRA',
    GB: 'ENG',
    GD: 'ENG',
    GE: 'ENG',
    GF: 'FRA',
    GG: 'ENG',
    GH: 'ENG',
    GI: 'ENG',
    GL: 'ENG',
    GM: 'ENG',
    GN: 'ENG',
    GP: 'FRA',
    GQ: 'ENG',
    GR: 'ELL',
    GS: 'ENG',
    GT: 'ENG',
    GU: 'ENG',
    GW: 'ENG',
    GY: 'ENG',
    HK: 'ENG',
    HM: 'ENG',
    HN: 'SPA',
    HR: 'HRV',
    HT: 'FRA',
    HU: 'HUN',
    ID: 'ENG',
    IE: 'ENG',
    IL: 'ENG',
    IM: 'ENG',
    IN: 'ENG',
    IO: 'ENG',
    IQ: 'ENG',
    IR: 'ENG',
    IS: 'ISL',
    IT: 'ENG',
    JE: 'ENG',
    JM: 'ENG',
    JO: 'ARA',
    JP: 'JPN',
    KE: 'ENG',
    KG: 'ENG',
    KH: 'KHM',
    KI: 'ENG',
    KM: 'ENG',
    KN: 'ENG',
    KP: 'KOR',
    KR: 'KOR',
    KW: 'ARA',
    KY: 'ENG',
    KZ: 'ENG',
    LA: 'LAO',
    LB: 'ARA',
    LC: 'ENG',
    LI: 'ENG',
    LK: 'ENG',
    LR: 'ENG',
    LS: 'ENG',
    LT: 'LIT',
    LU: 'ENG',
    LV: 'LAV',
    LY: 'ARA',
    MA: 'ENG',
    MC: 'FRA',
    MD: 'ENG',
    ME: 'ENG',
    MF: 'FRA',
    MG: 'ENG',
    MH: 'ENG',
    MK: 'ENG',
    ML: 'ENG',
    MM: 'MYA',
    MN: 'ENG',
    MO: 'ENG',
    MP: 'ENG',
    MQ: 'FRA',
    MR: 'ENG',
    MS: 'ENG',
    MT: 'ENG',
    MU: 'ENG',
    MV: 'DIV',
    MW: 'ENG',
    MX: 'SPA',
    MY: 'ENG',
    MZ: 'ENG',
    NA: 'ENG',
    NC: 'FRA',
    NE: 'ENG',
    NF: 'ENG',
    NG: 'ENG',
    NI: 'SPA',
    NL: 'ENG',
    NO: 'ENG',
    NP: 'NEP',
    NR: 'ENG',
    NU: 'ENG',
    NZ: 'ENG',
    OM: 'ARA',
    PA: 'SPA',
    PE: 'ENG',
    PF: 'FRA',
    PG: 'ENG',
    PH: 'ENG',
    PK: 'ENG',
    PL: 'POL',
    PM: 'FRA',
    PN: 'ENG',
    PR: 'ENG',
    PS: 'ARA',
    PT: 'POR',
    PW: 'ENG',
    PY: 'ENG',
    QA: 'ARA',
    RE: 'FRA',
    RO: 'RON',
    RS: 'ENG',
    RU: 'ENG',
    RW: 'ENG',
    SA: 'ARA',
    SB: 'ENG',
    SC: 'ENG',
    SD: 'ENG',
    SE: 'ENG',
    SG: 'ENG',
    SH: 'ENG',
    SI: 'ENG',
    SJ: 'NOB',
    SK: 'SLK',
    SL: 'ENG',
    SM: 'ITA',
    SN: 'ENG',
    SO: 'ENG',
    SR: 'NLD',
    SS: 'ENG',
    ST: 'POR',
    SV: 'SPA',
    SY: 'ENG',
    SZ: 'ENG',
    TC: 'ENG',
    TD: 'ENG',
    TF: 'ENG',
    TG: 'ENG',
    TH: 'THA',
    TJ: 'TGK',
    TK: 'ENG',
    TL: 'POR',
    TM: 'TUK',
    TN: 'ENG',
    TO: 'ENG',
    TR: 'TUR',
    TT: 'ENG',
    TV: 'ENG',
    TW: 'ZHO',
    TZ: 'ENG',
    UA: 'ENG',
    UG: 'ENG',
    UM: 'ENG',
    US: 'ENG',
    UY: 'SPA',
    UZ: 'ENG',
    VA: 'ITA',
    VC: 'ENG',
    VE: 'SPA',
    VG: 'ENG',
    VI: 'ENG',
    VN: 'VIE',
    VU: 'ENG',
    WF: 'FRA',
    WS: 'ENG',
    XK: 'SQI',
    XX: 'ENG',
    YE: 'ARA',
    YT: 'FRA',
    ZA: 'ENG',
    ZM: 'ENG',
    ZW: 'ENG',
};

export const countryCodeToLanguageCode = (countryCode: string): string =>
    //@ts-ignore-next-line
    ccToLc[countryCode];
